// extracted by mini-css-extract-plugin
export default {"sidePanel":"SidePanel_sidePanel__btMSw"};